export class RegistrationPageForm {
  allowedProjectIds?: string[];
  urlSlug?: string;
  unitLabel?: string;
  headerTextColor?: string;
  bgColor?: string;
  logoUrl?: string;
  addressOverride?: string;
  tncOverride?: string;
  thankYouOverride?: string;

  static GetInitialData(settings?: Record<string, any>, form?: RegistrationPageForm): RegistrationPageForm {
    return {
      allowedProjectIds: form?.allowedProjectIds || settings?.allowedProjectIds,
      urlSlug: form?.urlSlug || settings?.urlSlug,
      unitLabel: form?.unitLabel || settings?.unitLabel,
      headerTextColor: form?.headerTextColor || settings?.headerTextColor,
      bgColor: form?.bgColor || settings?.bgColor,
      logoUrl: form?.logoUrl || settings?.logoUrl,
      addressOverride: form?.addressOverride || settings?.addressOverride,
      tncOverride: form?.tncOverride || settings?.tncOverride,
      thankYouOverride: form?.thankYouOverride || settings?.thankYouOverride
    };
  }
}
